/**
 * Maintained by Sandon
 */
<template>
  <div
    v-if="visible"
    class="sy-cascader sy-cascader--clr"
    ref="cascade"
    :style="{'max-width': `${maxWidth}px`, 'overflow-x': isScroll ? 'scroll': 'hidden'}">
    <!--border-default-color-->
    <div class="sy-cascader__wrapper" :style="{'width': `${layersContentWidth}px`}">
      <div
        class="sy-cascader__layer"
        ref="cascadeLayer"
        v-for="layerNode in showedLayerNodes"
        :key="layerNode.key"
        v-if="layerNode.childNodes.length"
        :style="{height: `${layerHeight}px`}">
        <div class="sy-cascader__layer-list" :style="{width: `${layerWidth}px`}">
          <ul>
            <li
              class="sy-layer-list__item sy-cascader--clr"
              :class="{
              showed: showedLayerNodesMap[childNode.id],
              'single-selected': _isSingleSelected(childNode)
            }"
              v-for="childNode in layerNode.childNodes"
              :key="childNode.key"
              @click.stop="_nodeClick(childNode)">
              <!--特殊添加的"暂不选择"项，针对单选+非必须叶子节点-->
              <span
                class="sy-layer-list__item-label"
                :style="{width: `${layerWidth - 30}px`}"
                v-if="childNode.options && childNode.options.singleAndNotMustLeaf">
              {{pageText.notChoose}}
            </span>
              <!--普通的选择项-->
              <template v-else>
                <!--checkbox在被点击时会触发两次click事件-->
                <span
                  class="sy-cascader--left"
                  v-if="multiple"
                  @click.stop="_checkClick(childNode, $event)">
                <el-checkbox
                  class="sy-cascader__checkbox"
                  :indeterminate="childNode.indeterminate"
                  :disabled="childNode.disabled || !(multiple && (!mustLeaf || childNode.isLeaf))"
                  v-model="childNode.checked"
                  @change="_checkChange(childNode, true, true)">
                </el-checkbox>
              </span>
                <!-- - (isIE ? 16 : 0)-->
                <span
                  :style="{width: `${layerWidth - 30 - 14 - (multiple ? 20 : 0)}px`}"
                  class="sy-layer-list__item-label sy-cascader--left"
                  :title="childNode.label">
                {{childNode.label}}
              </span>
                <!--<span class="sy-layer-list__item-label" style="float: left; width: 35px">11</span>-->
                <i
                  v-if="!childNode.isLeaf"
                  class="sy-layer-list__arrow-icon sy-cascader--right el-icon-arrow-right">
                </i>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Node, {defaultProps, checkChange} from './Node'
  import NP from 'number-precision'
  import {arrayContentSame} from './utils'
  import i18n from './i18n'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'cascader',
    props: {
      // 树的数据
      data: Array,
      lazy: {type: Boolean, default: false},
      load: {type: Function},
      props: Object,
      multiple: {type: Boolean, default: false},
      mustLeaf: {type: Boolean, default: false},
      // 选中条目的keys
      selectedKeys: Array,
      layerWidth: Number,
      layerHeight: {type: Number, default: 160},
      defaultLoadFirst: {type: Boolean, default: true},
      maxWidth: {type: Number, default: 1000},
      // 自动展开
      expandPath: {type: Array, default: () => []},
      visible: {type: Boolean, default: true},
      // 选中条目展示分隔符，表示串起来的各节点的label的分隔字符，会影响 Node.completeLabel 值
      labelDivider: {type: String, default: '/'}
    },
    data () {
      const root = new Node({
        level: 0,
        data: {},
        props: this.props,
        labelDivider: this.labelDivider
      })
      return {
        pageText,
        root: root,
        showedLayerNodes: [root], // 层级展示节点
        // 选中的节点的数组
        selectedNodes: {
          completeNodes: [], // 完整的
          simpleNodes: [] // 去掉了祖先已在选中数组中的节点
        },
        unInitSelectedKeys: [],
        layersContentWidth: this.layerWidth,
        isScroll: false,
        scrollLeft: 0,
        isIE: (!!window.ActiveXObject || 'ActiveXObject' in window)
      }
    },
    computed: {
      // 层级展示节点 的map结构
      showedLayerNodesMap: function () {
        return this._genMap(this.showedLayerNodes)
      }
    },
    watch: {
      selectedKeys: function (newVal, oldVal) {
        // 如果 selectedKeys 有改变，则以 selectedKeys 为准重新渲染
        let existSelectedKeys = this.selectedNodes.simpleNodes.map(node => node.key)
        existSelectedKeys = existSelectedKeys.concat(this.unInitSelectedKeys)

        if (!arrayContentSame(existSelectedKeys, this.selectedKeys)) {
          this._initSelected()
        }
      },
      data: function () {
        if (this.data) {
          this.lazy = false
          this._initTree()
          this._initSelected()
        }
      },
      showedLayerNodes: function () {
        this._notifyWidthChange()
      },
      visible: function () {
        if (this.visible) {
          this._notifyWidthChange()
          this.initScroll()
        }
      }
    },
    created () {
      // 渲染树
      if (this.data) {
        this.lazy = false
        this._initTree()
        this._initSelected()
      } else if (this.lazy && this.load) {
        if (this.multiple) {
          this.unInitSelectedKeys = this.selectedKeys || []
        } else {
          this.unInitSelectedKeys = (this.selectedKeys && this.selectedKeys.length && [this.selectedKeys[0]]) || []
        }
        if (this.defaultLoadFirst) {
          this.firstLoad()
        } else {
          // 只是通知 unInitSelectedKeys
          this._notify(true)
        }
      }
    },
    methods: {
      // 全量初始化预选中
      _initSelected () {
        // console.log('初始化预选中')
        if (!this.selectedKeys)  return

        // 找到所有能初始化的节点, 以及剩下的未被初始化的id
        let selectedIdsMap = {}
        this.selectedKeys.forEach((id) => {
          selectedIdsMap[id] = true
        })
        let arr = this.root.childNodes
        const selected = []
        for (let i = 0; i !== arr.length; i++) {
          if (selectedIdsMap[arr[i].key]) {
            selected.push(arr[i])
            delete selectedIdsMap[arr[i].key]
          }
          arr = arr.concat(arr[i].childNodes)
        }

        // 先重置清空
        this.reset(true, true)

        // 修改未初始化的id
        this.unInitSelectedKeys = Object.keys(selectedIdsMap)

        // 对初始化的节点进行渲染，并通知，分单选/多选
        if (this.multiple) {
          selected.forEach((node) => {
            node.checked = true
            this._checkChange(node, false, false)
          })
          this._updateSelectedNodes(true)
        } else {
          if (selected.length) {
            this._setSelectedNode(selected[0], true)
          } else {
            // 只是通知 unInitSelectedKeys
            this._notify(true)
          }
        }
      },
      // 懒加载数据时，针对新加载的数据初始化预选中
      _lazyLoadInitSelected (nodes, silent) {
        // console.log('懒加载执行初始化')
        if (!this.unInitSelectedKeys.length) return

        let selectedIdsMap = {}
        this.unInitSelectedKeys.forEach((id) => {
          selectedIdsMap[id] = true
        })

        const selected = []
        nodes.forEach((node) => {
          if (selectedIdsMap[node.key]) {
            selected.push(node)
            delete selectedIdsMap[node.key]
          }
        })
        this.unInitSelectedKeys = Object.keys(selectedIdsMap)

        // 即使selected为空，也能调用_notify发出'change'事件
        // if (!selected.length) return

        if (this.multiple) {
          selected.forEach((node) => {
            node.checked = true
            this._checkChange(node, false, false)
          })
          // this._updateSelectedNodes(silent || !selected.length)
          this._updateSelectedNodes(true)
        } else {
          if (!this.selectedNodes.completeNodes.length && selected.length) {
            this._setSelectedNode(selected[0], true)
          } else {
            // 只是通知 unInitSelectedKeys
            this._notify(true)
          }
        }
      },
      // 基于 data 属性初始化一棵树
      _initTree () {
        const childrenKey = this.props['children'] || defaultProps['children']
        this.root.data[childrenKey] = this.data
        let arr = [this.root]
        for (let i = 0; i !== arr.length; i++) {
          this._loadCb(arr[i], null, (arr[i].data && arr[i].data[childrenKey]) || [])
          arr = arr.concat(arr[i].childNodes)
        }
        this.$emit('tree-initialized', this.root)
      },
      // load 属性中传入的cb，使用data数组为node节点渲染子元素
      _loadCb (parent, cb, dataArr) {
        !dataArr && (dataArr = [])
        if (!Array.isArray(dataArr)) {
          throw new Error('load data should be Array')
        }
        parent.loaded = true
        parent.isLeaf = dataArr.length === 0
        // 添加"暂不选择"子节点
        if (!this.multiple && !this.mustLeaf && parent.level !== 0 && !parent.isLeaf) {
          parent.appendDataChild(null, {
            singleAndNotMustLeaf: true,
            loaded: true,
            isLeaf: true
          })
        }
        // 添加其他子节点
        dataArr.forEach(data => parent.appendDataChild(data))

        // 懒加载时
        if (this.lazy) {
          // 此节点选中，所以子节点也会被选中
          if (this.multiple && parent.checked && parent.childNodes.length) {
            this._updateSelectedNodes()
          }

          // 初始化
          if (this.unInitSelectedKeys.length) {
            this._lazyLoadInitSelected(parent.childNodes, true)
          }
        }

        // 回调
        cb && cb()
      },
      // 节点被点击
      _nodeClick (node) {
        if (node.singleAndNotMustLeaf) {
          // "暂不选择"被点击
          this._setSelectedNode(node.parent)
        } else if (!this.multiple && node.isLeaf) {
          // 如果是单选模式下选中叶子节点
          this._setSelectedNode(node)
        }

        // 加载未加载的子级数据
        if (this.lazy && !node.isLeaf && !node.loaded) {
          const cbAfterLoad = () => {
            // 单选的叶子节点在点击时，load完在确定其为叶子节点后，选中此叶子节点
            // if (!this.multiple && node.loaded && node.isLeaf) {
            //   this._setSelectedNode(node)
            // }

            // cascade宽度变化了
            this._notifyWidthChange()
          }
          this.load(node, this._loadCb.bind(this, node, cbAfterLoad))
        }
        // 修改该展示的层级
        this._changeShowedLayer(node)
      },
      _changeShowedLayer (node) {
        // 修改该展示的层级
        const newShowedLayerNodes = []
        let tmp = node
        while (tmp) {
          newShowedLayerNodes.unshift(tmp)
          tmp = tmp.parent
        }
        this.showedLayerNodes = newShowedLayerNodes
      },
      // 对node数组生成map
      _genMap (list, idPropName = 'id') {
        const map = {}
        list.forEach(node => {
          map[node[idPropName]] = node
        })
        return map
      },
      // node的checked改变，从而改变对应的祖先和子孙节点
      _checkChange (node, callUpdate = false, emitCheckChangeEvent = false) {
        // console.log('check change')
        checkChange(node)

        // 更新选中节点数组
        callUpdate && this._updateSelectedNodes()

        // 事件
        emitCheckChangeEvent && this.$emit('check-change', node)
      },
      // checkbox被点击
      _checkClick (node, event) {
        let classNames = event.target.className.trim().split(' ').filter(cls => !!cls)
        if (classNames.includes('el-checkbox__inner')) {
          this.$emit('checkbox-click', node)
        }
      },
      // 复选模式下，遍历node tree，更新选中节点数组`selectedNodes`
      _updateSelectedNodes (isSilent) {
        // console.log('duo xuan', this.unInitSelectedKeys)
        // 广度优先遍历树，获取选中的节点,注意不要选择根节点
        const selected = [] // 所有选中的
        let arr = [this.root]
        for (let i = 0; i !== arr.length; i++) {
          const node = arr[i]
          node.parent && node.checked && !node.indeterminate && selected.push(node)
          arr = arr.concat(node.childNodes)
        }

        // 去掉祖先已经在其中的
        const selectedNodesMap = this._genMap(selected)
        const filteredNodes = selected.filter((node) => {
          let parent = node.parent
          return parent && !selectedNodesMap[parent.id]
        })

        // 最终的数据
        this.selectedNodes = {
          completeNodes: selected,
          simpleNodes: filteredNodes
        }

        this._notify(isSilent)
        return this.selectedNodes
      },
      // 单选模式下，更新选中节点
      _setSelectedNode (node, isSilent) {
        // console.log('dan xuan')
        if (node && !node.parent) return // 根节点不让选中

        // 已选的先清掉
        this.selectedNodes.completeNodes.forEach((node) => {
          node.checked = false
          this._checkChange(node, false, false)
        })
        // 把目标节点选中
        if (node) {
          node.checked = true
          this._checkChange(node, false, false)
        }
        // 清空 unInitSelectedKeys
        this.unInitSelectedKeys = []

        // 更新selectedNodes
        const nodes = node ? [node] : []
        let completeNodes = nodes
        for (let i = 0; i !== completeNodes.length; i++) {
          completeNodes = completeNodes.concat(completeNodes[i].childNodes)
        }
        this.selectedNodes = {
          completeNodes: completeNodes,
          simpleNodes: nodes
        }
        this._notify(isSilent)
        return this.selectedNodes
      },
      // 事件通知
      _notify (isSilent) {
        this.$emit(isSilent ? 'silent-change' : 'change', Object.assign(
          {
            unInitSelectedKeys: this.unInitSelectedKeys
          },
          this.selectedNodes,
          {
            complete: this.selectedNodes.completeNodes.map(node => node.data),
            simple: this.selectedNodes.simpleNodes.map(node => node.data)
          })
        )
      },
      // 单选时，某项是否选中
      _isSingleSelected (node) {
        if (this.multiple) return false
        if (node.indeterminate) return true
        if (node.checked) {
          if (node === this.selectedNodes.simpleNodes[0]) return true
          if (node.singleAndNotMustLeaf && node.parent === this.selectedNodes.simpleNodes[0]) return true
        }
      },
      // 重置cascade的宽度
      _notifyWidthChange () {
        // todo 改成取gutter的值之后，就不会依赖于 this.$refs['cascadeLayer']
        // todo 依赖它的缺点是，第一次渲染多个层级时，会依赖 $nextTick 以等 $refs['cascadeLayer'] 渲染
        this.$nextTick(() => {
          if (this.$refs['cascadeLayer'] && this.$refs['cascadeLayer'].length) {
            let realLayerWidth = this.$refs['cascadeLayer'][0].getBoundingClientRect().width
            realLayerWidth = NP.plus(realLayerWidth, 1)
            const showedLevels = this.showedLayerNodes
              .filter(node => node.childNodes.length)
              .length
            this.layersContentWidth = Math.ceil(NP.minus(NP.times(showedLevels, realLayerWidth), 1))
            this.isScroll = this.layersContentWidth > this.maxWidth
            const containerWidth = this.isScroll ? this.maxWidth : this.layersContentWidth
            this.$emit('width-change', containerWidth)
            this.scrollLeft = this.isScroll ? this.layersContentWidth - this.maxWidth : 0
            this.initScroll()
          }
        })
      },
      // 对外接口，取消对节点的选择, 参数nodes可以是Node的数组，也可以是data的数组，或两者混合
      unselectNodes (nodes, isSilent) {
        if (!Array.isArray(nodes)) return
        if (isSilent && !nodes.length) return

        // 未初始化的数据，直接从数组中过滤掉
        const unInitData = nodes.filter(node => !node._isTreeNode)
        const keyPropName = this.props['key'] || defaultProps['key']
        const unInitDataMap = this._genMap(unInitData, keyPropName)
        this.unInitSelectedKeys = this.unInitSelectedKeys.filter(id => !unInitDataMap[id])

        // 已经在UI中展示的
        nodes = nodes.filter(node => node._isTreeNode)
        if (this.multiple) {
          // 多选
          nodes.forEach((node) => {
            node.checked = false
            this._checkChange(node, false, false)
          })
          this._updateSelectedNodes(isSilent)
        } else {
          this._setSelectedNode(null, isSilent)
        }
      },
      // 对外接口，根据keys取消对节点的选择
      unselectKeys (keys, isSilent) {
        const keySet = new Set(keys)
        const nodes = []
        let arr = [this.root]
        for (let i = 0; i !== arr.length; i++) {
          if (keySet.has(arr[i].key)) {
            nodes.push(arr[i])
            keySet.delete(arr[i].key)
          }

          arr = arr.concat(arr[i].childNodes)
        }

        if (keySet.size) {
          const tmp = new Set(this.unInitSelectedKeys)
          keySet.forEach((value, key) => {
            tmp.delete(value)
          })
          this.unInitSelectedKeys = [...tmp]
        }

        this.unselectNodes(nodes, isSilent)
      },
      // 对外接口，选中节点, 参数`nodes`是Node的数组，通过`resetFirst`来控制增量和全量
      selectNodes (nodes, isSilent, resetFirst = true) {
        if (!Array.isArray(nodes)) return
        if (isSilent && !nodes.length) return

        resetFirst && this.reset(true, true)

        // 已经在UI中展示的
        nodes = nodes.filter(node => node._isTreeNode)
        if (this.multiple) {
          // 多选
          nodes.forEach((node) => {
            node.checked = true
            this._checkChange(node, false, false)
          })
          this._updateSelectedNodes(isSilent)
        } else {
          this._setSelectedNode(nodes[0], isSilent)
        }
      },
      // 对外接口，根据keys选中节点, 多选增量，单选全量
      selectKeys (keys, isSilent) {
        const keySet = new Set(keys)
        const nodes = []
        let arr = [this.root]
        for (let i = 0; i !== arr.length; i++) {
          if (keySet.has(arr[i].key)) {
            nodes.push(arr[i])
            keySet.delete(arr[i].key)
          }

          arr = arr.concat(arr[i].childNodes)
        }

        const leftKeys = [...keySet]

        if (!this.multiple) {
          // 单选
          this.reset(true, true)
          if (nodes.length) {
            this.selectNodes([nodes[0]], isSilent, false)
          } else if (leftKeys.length) {
            this.unInitSelectedKeys = [leftKeys[0]]
            this._notify(isSilent)
          }
        } else {
          // 多选
          if (leftKeys.length) {
            let tmp = this.unInitSelectedKeys
            tmp = tmp.concat(leftKeys)
            this.unInitSelectedKeys = [...(new Set(tmp))]
          }

          this.selectNodes(nodes, isSilent, false)
        }
      },
      // 对外接口，重置
      reset (keepShowedLayer, isSilent, deep) {
        if (deep) {
          this.root = new Node({
            level: 0,
            props: this.props,
            labelDivider: this.labelDivider
          })
        }
        !keepShowedLayer && (this.showedLayerNodes = [this.root]) // 层级展示节点

        this.unInitSelectedKeys = []
        this.unselectNodes(this.selectedNodes.completeNodes, isSilent) // 取消对选中的节点的选中
      },
      // 对外及对内接口，懒加载时加载第一级
      firstLoad () {
        if (this.lazy && this.load) {
          if (!this.expandPath.length) {
            this.load(this.root, this._loadCb.bind(this, this.root, null))
          } else {
            this.load(this.root, this._loadCb.bind(this, this.root, () => {
              // this.$nextTick(() => {
              this._expand(this.root, 0)
              // })
            }))
          }
        }
      },
      _expand (parent, expandPathIndex) {
        const key = this.expandPath[expandPathIndex]
        const node = parent.childNodes.find(node => node.key === key)
        const newIndex = expandPathIndex + 1
        if (newIndex < this.expandPath.length) {
          this.load(node, this._loadCb.bind(this, node, () => {
            this._expand(node, newIndex)
          }))
        } else {
          this.load(node, this._loadCb.bind(this, node, () => {
            this._changeShowedLayer(node)
          }))
        }
      },
      // 对外接口
      initScroll () {
        if (this.isScroll) {
          this.$nextTick(() => {
            this.$el.scrollLeft = this.scrollLeft
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .sy-cascader{
    /*display: inline-block;*/
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    width: 100%; /*ie9*/
    /*font-size: 12px;*/
  }
  .sy-cascader--clr {
    *zoom:1;
  }
  .sy-cascader--clr:after {
    display:block;
    clear:both;
    width: 0;
    height:0;
    content:"\0020";
  }
  .sy-cascader--right{
    float: right;
  }
  .sy-cascader--left{
    float: left;
  }
  .sy-cascader__layer{
    box-sizing: border-box;
    float: left;
    /*height: 160px;*/
    border-left: 1px solid rgba(0,0,0,0.15);
    padding: 10px 0;
    overflow-y: scroll;
    overflow-x: hidden;
    background: #fff;
  }
  .sy-cascader__layer:first-child{
    border-left: none;
  }

  .sy-cascader__layer-list{
    overflow-x: hidden;
  }
  .sy-layer-list__item{
    /*box-sizing: border-box;*/
    height: 32px;
    line-height: 32px;
    padding: 0 15px;
    overflow: hidden;
    &.showed{
      background: #F3F8FF;
    }
    &.single-selected{
      /*background: #F3F8FF;*/
      color: #409eff;
    }
  }
  .sy-layer-list__arrow-icon{
    margin: 9px 0 auto 0;
  }
  .sy-layer-list__item-label{
    overflow: hidden;
    height: 32px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sy-cascader__checkbox{
    padding-right: 6px;
  }
</style>
